import { defineComponent as T, reactive as w, computed as i, ref as m, openBlock as z, createElementBlock as A, normalizeStyle as B, normalizeClass as N, unref as a, renderSlot as s, createElementVNode as p, mergeProps as c } from "vue";
import { timePickerRangeTriggerProps as D } from "./index581.js";
import { useFormItem as L, useFormItemInputId as j } from "./index585.js";
import { useAttrs as q } from "./index698.js";
import { useNamespace as f } from "./index559.js";
import { useFocusController as G } from "./index587.js";
const H = ["id", "name", "placeholder", "value", "disabled"], J = ["id", "name", "placeholder", "value", "disabled"];
var _ = /* @__PURE__ */ T({
  name: "PickerRangeTrigger",
  inheritAttrs: !1,
  __name: "picker-range-trigger",
  props: D,
  emits: [
    "mouseenter",
    "mouseleave",
    "click",
    "touchstart",
    "focus",
    "blur",
    "startInput",
    "endInput",
    "startChange",
    "endChange"
  ],
  setup(h, { expose: v, emit: g }) {
    const r = h, n = g, { formItem: I } = L(), { inputId: b } = j(
      w({ id: i(() => {
        var e;
        return (e = r.id) == null ? void 0 : e[0];
      }) }),
      {
        formItemContext: I
      }
    ), l = q(), C = f("date"), u = f("range"), t = m(), d = m(), { wrapperRef: k, isFocused: R } = G(t, {
      disabled: i(() => r.disabled)
    }), P = (e) => {
      n("click", e);
    }, y = (e) => {
      n("mouseenter", e);
    }, E = (e) => {
      n("mouseleave", e);
    }, S = (e) => {
      n("touchstart", e);
    }, V = (e) => {
      n("startInput", e);
    }, $ = (e) => {
      n("endInput", e);
    }, F = (e) => {
      n("startChange", e);
    }, M = (e) => {
      n("endChange", e);
    };
    return v({
      focus: () => {
        var e;
        (e = t.value) == null || e.focus();
      },
      blur: () => {
        var e, o;
        (e = t.value) == null || e.blur(), (o = d.value) == null || o.blur();
      }
    }), (e, o) => (z(), A(
      "div",
      {
        ref_key: "wrapperRef",
        ref: k,
        class: N([a(C).is("active", a(R)), e.$attrs.class]),
        style: B(
          // https://github.com/vuejs/language-tools/issues/2104#issuecomment-3092541527
          e.$attrs.style
        ),
        onClick: P,
        onMouseenter: y,
        onMouseleave: E,
        onTouchstartPassive: S
      },
      [
        s(e.$slots, "prefix"),
        p("input", c(a(l), {
          id: a(b),
          ref_key: "inputRef",
          ref: t,
          name: e.name && e.name[0],
          placeholder: e.startPlaceholder,
          value: e.modelValue && e.modelValue[0],
          class: a(u).b("input"),
          disabled: e.disabled,
          onInput: V,
          onChange: F
        }), null, 16, H),
        s(e.$slots, "range-separator"),
        p("input", c(a(l), {
          id: e.id && e.id[1],
          ref_key: "endInputRef",
          ref: d,
          name: e.name && e.name[1],
          placeholder: e.endPlaceholder,
          value: e.modelValue && e.modelValue[1],
          class: a(u).b("input"),
          disabled: e.disabled,
          onInput: $,
          onChange: M
        }), null, 16, J),
        s(e.$slots, "suffix")
      ],
      38
      /* CLASS, STYLE, NEED_HYDRATION */
    ));
  }
});
export {
  _ as default
};
